
window.theme = window.theme || {};

window.theme.cartQntHandle = () => {
  let qntInputs = document.querySelectorAll('.cart-qnt input[name="quantity"]');
  qntInputs.forEach(input => {
    input.addEventListener('change', (e) => {
      let that = e.currentTarget;
      let inputBtns = that.parentElement.querySelectorAll('.qnt-input');
      let currIndex = that.closest('tr').dataset.index;
      let cartCount = document.querySelector('[data-cart-count]');

      // disable qnt btn to prefent the input with negative values
      inputBtns.forEach(btn => btn.disabled = true)

      // update cart
      fetch(window.theme.routes.cart_change_url,{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({'line': currIndex,'quantity': that.value})
      })
      .then(res => res.json())
      .then(res => {
        if (res.errors) {
          that.value =  parseInt(that.value) - 1;
          console.log(that.value);
          that.closest('.cart-qnt').querySelector('.error').style.display = null;
          that.closest('.cart-qnt').querySelector('[data-error-text]').textContent = res.errors;
          setTimeout(() => {
            that.closest('.cart-qnt').querySelector('.error').style.display = 'none'
          }, 2500);
        } else if(that.value < 0) {
          that.closest('.cart-qnt').querySelector('.error').style.display = null;
          that.closest('.cart-qnt').querySelector('[data-error-text]').textContent = theme.cart_qnt_error.replace('{{ quantity }}', res.item_count);
          setTimeout(() => {
            that.closest('.cart-qnt').querySelector('.error').style.display = 'none'
          }, 2500); 
          
          // update quantity
          that.value = res.item_count;
        }
        else if(res.item_count == 0){
          location.reload();
        } else {
          console.log(that.value);
          if (that.value == 0) that.closest('tr').remove()
          cartCount.innerHTML = res.item_count;
          if (res.item_count != 0) {
            cartCount.style.display = null
          } else {
            cartCount.style.display = 'none'
          }
          that.closest('tr').querySelector('[data-total-price]').innerHTML = window.theme.formatMoney(res.items[currIndex - 1].line_price,window.theme.money_format);
          document.querySelector('[data-total-cart-price]').innerHTML = window.theme.formatMoney(res.items_subtotal_price,window.theme.money_format);
        }
        // handle increse decrease button in quantity update
        inputBtns.forEach(btn => {
          (that.value == 1 && btn.classList.contains('qnt-dec')) ? btn.disabled = true : btn.disabled = false;
        })
        theme.onScrollAnimation();
      })
    })
  }) 
}


window.addEventListener('DOMContentLoaded', () => {
  window.theme.cartQntHandle();
})